import { z } from 'zod';

export const facilityRoleValues = [
  'receiving',
  'shipping',
  'dismantling',
  'storage',
  'admin',
] as const;
export type FacilityRole = (typeof facilityRoleValues)[number];

export const facilitySchema = z.object({
  facility_id: z.string(),
  company_id: z.string(),
  company_display_name: z.string(),
  company_party_type: z.enum(['supplier', 'processor', 'platform']),
  facility_name: z.string(),
  facility_role: z.enum(facilityRoleValues),
  address: z.string().nullable().optional(),
  active_flag: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Facility = z.infer<typeof facilitySchema>;

export const companyOptionSchema = z.object({
  company_id: z.string(),
  display_name: z.string(),
  legal_name: z.string(),
  company_role: z.string(),
  party_type: z.enum(['supplier', 'processor', 'platform']),
});

export type CompanyOption = z.infer<typeof companyOptionSchema>;

export const facilityFormSchema = z.object({
  company_id: z.string().min(1, '会社を選択してください'),
  facility_name: z.string().min(1, '作業拠点名を入力してください'),
  address: z.string().optional(),
  facility_role: z.enum(facilityRoleValues),
  active_flag: z.boolean().optional(),
});

export type FacilityFormInput = z.infer<typeof facilityFormSchema>;

export interface FacilityCreateInput {
  company_id: string;
  facility_name: string;
  address?: string;
  facility_role: FacilityRole;
}

export interface FacilityUpdateInput {
  facility_name?: string;
  address?: string;
  facility_role?: FacilityRole;
  active_flag?: boolean;
}
